import { AlertTriangle, CloudLightning, Droplets, Flame, Mountain, Snowflake, Tornado, Umbrella, Waves } from 'lucide-react';

const hazards = [
  [Waves, 'Наводнение'], [Mountain, 'Землетрясение'], [Flame, 'Лесные пожары'], [Mountain, 'Сели, камнепады, оползни'],
  [Tornado, 'Ветер, ураган, тайфун'], [Tornado, 'Смерч'], [Snowflake, 'Лавины'], [CloudLightning, 'Удар молнии'],
  [AlertTriangle, 'Извержение вулкана'], [Waves, 'Цунами'], [CloudLightning, 'Градобитие'], [AlertTriangle, 'Карстовые проявления и провалы'], [Droplets, 'Подтопление грунтовыми водами'],
];

export default function Hazards() {
  return <section className="landing-section" id="hazards" aria-labelledby="hazards-title"><div className="landing-wrap">
    <header className="landing-section-heading"><h2 id="hazards-title">13 природных опасностей</h2><p>Комплексная мультиопасная оценка по единой методике на основе актуальных геоданных.</p></header>
    <div className="hazards-grid">{hazards.map(([Icon, title]) => <article className="hazard-card" key={title}><span className="hazard-icon"><Icon size={21} aria-hidden="true" /></span><h3>{title}</h3></article>)}</div>
  </div></section>;
}
